import { render, staticRenderFns } from "./YourOrder.vue?vue&type=template&id=6ff60152&scoped=true&"
import script from "./YourOrder.vue?vue&type=script&lang=js&"
export * from "./YourOrder.vue?vue&type=script&lang=js&"
import style0 from "./YourOrder.vue?vue&type=style&index=0&id=6ff60152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff60152",
  null
  
)

export default component.exports